import { useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Card } from "@/components/dash";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import api, { API, apiErr } from "@/lib/api";

export default function Settings() {
  const { user, refresh } = useAuth();
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const start2fa = async () => {
    setBusy(true);
    try { const { data } = await api.post("/auth/2fa/setup"); setSetup(data); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const enable2fa = async () => {
    setBusy(true);
    try { await api.post("/auth/2fa/enable", { code }); toast.success("2FA etkinleştirildi."); setSetup(null); setCode(""); refresh(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const disable2fa = async () => {
    try { await api.post("/auth/2fa/disable"); toast.success("2FA devre dışı bırakıldı."); refresh(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div>
      <PageHeader title="Ayarlar" desc="Hesap ve güvenlik ayarlarınızı yönetin." />
      <div className="space-y-6 max-w-2xl">
        <Card className="p-6">
          <h3 className="text-base font-bold mb-4">Hesap Bilgileri</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label className="text-sm">Ad Soyad</Label><Input defaultValue={user?.name} disabled className="mt-1.5" /></div>
            <div><Label className="text-sm">Firma</Label><Input defaultValue={user?.company} disabled className="mt-1.5" /></div>
            <div><Label className="text-sm">E-posta</Label><Input defaultValue={user?.email} disabled className="mt-1.5" /></div>
            <div><Label className="text-sm">Telefon</Label><Input defaultValue={user?.phone} disabled className="mt-1.5" /></div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center gap-2"><ShieldCheck size={18} className="text-primary" /><h3 className="text-base font-bold">İki Aşamalı Doğrulama (2FA)</h3></div>
          <p className="mt-2 text-sm text-muted-foreground">Hesabınızı ekstra bir güvenlik katmanıyla koruyun.</p>
          {user?.twofa_enabled ? (
            <div className="mt-4 flex items-center justify-between rounded-xl border border-emerald-500/20 bg-emerald-500/5 p-4">
              <span className="text-sm font-medium text-emerald-600">2FA aktif</span>
              <Button variant="outline" size="sm" onClick={disable2fa} data-testid="disable-2fa-btn" className="rounded-full">Devre Dışı Bırak</Button>
            </div>
          ) : setup ? (
            <div className="mt-4 space-y-3">
              <div className="mx-auto h-40 w-40 rounded-xl border border-border bg-white p-2">
                <img src={`${API}/qr?data=${encodeURIComponent(setup.otpauth_uri)}`} alt="2FA QR" className="h-full w-full" />
              </div>
              <p className="text-xs text-center text-muted-foreground">Google Authenticator ile tarayın veya kodu girin: <code className="font-mono">{setup.secret}</code></p>
              <div className="flex gap-2">
                <Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="6 haneli kod" data-testid="2fa-code" maxLength={6} className="text-center tracking-[0.3em]" />
                <Button onClick={enable2fa} disabled={busy} data-testid="enable-2fa-btn" className="rounded-full">{busy ? <Loader2 className="animate-spin" size={16} /> : "Etkinleştir"}</Button>
              </div>
            </div>
          ) : (
            <Button className="mt-4 rounded-full" onClick={start2fa} disabled={busy} data-testid="setup-2fa-btn">{busy ? <Loader2 className="animate-spin" size={16} /> : "2FA Kur"}</Button>
          )}
        </Card>
      </div>
    </div>
  );
}
